module.exports = __webpack_public_path__ + "static/021-b4d1df32f534a4f082ff901ef60428e0.jpg";